// extracted by mini-css-extract-plugin
module.exports = {"container":"_2DikeD525MjIyz62cU7zWb","cancelBtn":"_2_nKD48iGgzHjrhhq0GsVW","icon":"XYd8_4_XPPnlHQMvdIo55","saveBtn":"SxZ4XLfKhvQOWAyBxm7vn","rightButtons":"utwvqYJr8ktaPI7jmXYqP"};